"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
var _allianceAuthorization = require("@/api/allianceAuthorization");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      tableData: [{
        unionName: '淘宝',
        unionCode: 'TB',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '京东',
        unionCode: 'JD',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '拼多多',
        unionCode: 'PDD',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '唯品会',
        unionCode: 'WPH',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '抖音',
        unionCode: 'DY',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '快手',
        unionCode: 'KS',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '美团',
        unionCode: 'MT',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '饿了么',
        unionCode: 'ELM',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '滴滴',
        unionCode: 'DD',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '腾讯云选',
        unionCode: 'TX',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '直充卡券',
        unionCode: 'QF',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '在线点单',
        unionCode: 'OT',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '1688',
        unionCode: 'ALI',
        unionType: '',
        feeRate: 0
      }, {
        unionName: '淘宝直播',
        unionCode: 'ZB',
        unionType: '',
        feeRate: 0
      }],
      form: {
        feeRate: null
      },
      rules: {
        feeRate: [{
          required: true,
          message: '请输入技术服务费比例',
          trigger: 'blur'
        }]
      },
      platformType: null,
      dialogVisible: false,
      title: ''
    };
  },
  created: function created() {
    this.loadFeeRateApi();
  },
  methods: {
    onFeeRateInput: function onFeeRateInput(val) {
      // 只允许输入数字和一个小数点
      var newVal = val.replace(/[^\d.]/g, ''); // 只保留数字和.
      // 只允许出现一个小数点
      newVal = newVal.replace(/\.{2,}/g, '.');
      newVal = newVal.replace(/^(\d+)\.(\d*)\./, '$1.$2');
      // 小数点不能在首位
      newVal = newVal.replace(/^\./g, '');
      // 保证只能有一位小数点
      newVal = newVal.replace(/(\.\d*)\./g, '$1');
      this.form.feeRate = newVal;
    },
    handleClick: function handleClick(data) {
      this.title = data.unionName + '技术服务费编辑';
      this.form.feeRate = data.feeRate;
      this.platformType = data.unionCode;
      this.dialogVisible = true;
    },
    loadFeeRateApi: function () {
      var _loadFeeRateApi = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _this = this;
        var params, res, rateList, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {};
              _context.n = 1;
              return (0, _allianceAuthorization.loadFeeRate)(params);
            case 1:
              res = _context.v;
              console.log(res);
              if (res.data) {
                rateList = res.data.rateList || [];
                rateList.forEach(function (rateItem) {
                  var target = _this.tableData.find(function (item) {
                    return item.unionCode === rateItem.unionCode;
                  });
                  if (target) {
                    Object.assign(target, rateItem);
                  }
                });
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      function loadFeeRateApi() {
        return _loadFeeRateApi.apply(this, arguments);
      }
      return loadFeeRateApi;
    }(),
    saveConfigApi: function () {
      var _saveConfigApi = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(params) {
        var res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _allianceAuthorization.saveFeeRate)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.onClose();
                this.loadFeeRateApi();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function saveConfigApi(_x) {
        return _saveConfigApi.apply(this, arguments);
      }
      return saveConfigApi;
    }(),
    onClose: function onClose() {
      this.platformType = null;
      this.resetForm('formRef');
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log('valid');
          _this2.$confirm('是否确认确认修改联盟技术服务费?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            var params = {
              unionCode: _this2.platformType,
              feeRate: _this2.form.feeRate
            };
            _this2.saveConfigApi(params);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.form = {
        feeRate: 0
      };
      this.$refs[formName].resetFields();
    }
  }
};